// ── Canonical avatar palette ──────────────────────────────────────────────────
// One palette + one hash so the same person gets the same color on every surface.
// IMPORTANT: AVATAR_COLORS values must stay RAW HEX — several call sites alpha-concat
// (`${color}cc`), which breaks with var() tokens or gradients (backlog 🧹 15.87).
//
// 2026-06-30 rework: hash the FULL name (was first-char only, which collided
// Melissa/Marianne/Michael), 12 vibrant hues, and a paired `avatarGradient` so
// avatars read premium (two-tone + depth) instead of flat single-color discs.
export const AVATAR_COLORS = ['#6c7ae0','#e17055','#00b894','#e84393','#f0a93b','#0984e3','#a55eea','#26c6c6','#ff6b81','#4dabf7','#ff9f43','#2ed573']
const AVATAR_DEEP          = ['#4453b8','#b94e34','#00876c','#b81f6e','#cf8417','#0660aa','#7d3fc0','#169a9a','#d8455c','#2b82cc','#e07b1d','#1aa856']

const hashName = (s) => {
  const str = (s == null || s === '') ? '?' : String(s)
  let h = 0
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0
  return h
}

// Raw-hex base color (safe to alpha-concat). Stable per full name.
export const avatarColor = (s) => AVATAR_COLORS[hashName(s) % AVATAR_COLORS.length]

// Premium two-tone gradient for avatar backgrounds (base → deeper shade, same hue).
export const avatarGradient = (s) => {
  const i = hashName(s) % AVATAR_COLORS.length
  return `linear-gradient(140deg, ${AVATAR_COLORS[i]}, ${AVATAR_DEEP[i]})`
}

export const initialOf = (s) => ((s || '?').trim().charAt(0) || '?').toUpperCase()
